module.exports = __webpack_public_path__ + "static/media/建筑类型.3bc21a24.svg";